import { AxiosInstance } from "axios"

export interface GetAgencyUsersRequest {
  page: number
  size: number
  keyword?: string
  csv?: boolean
}

export interface AgencyUser {
  user_id: number
  first_name: string
  last_name: string
  email: string
  mobile: string
  dialer_code: string
  role: "OWNER" | "MEMBER"
  invite_status: "PENDING" | "ACCEPTED" | "EXPIRED"
  ta_price_config_id: number
  invited_by_name: string | null
  total_bookings: number
  total_commission: number
}

export interface GetAgencyUsersResponse {
  time: string
  apiStatus: string
  data: {
    taPriceConfigId: number
    totalUsers: number
    page: number
    size: number
    totalPages: number
    last: boolean
    first: boolean
    numberOfElements: number
    content: AgencyUser[]
  }
}

export function getAgencyUsersApi(
  params: GetAgencyUsersRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: "/agent/agency/users",
    params,
    responseType: params.csv ? "blob" : "json",
  }) as Promise<{ data: GetAgencyUsersResponse }>
}
